import { Deserializable } from '../../protocols/deserializable';
import { LeaveDetailsType } from '../../employers/employer-history/types/leave-details-type';
import * as moment from 'moment/moment';

export class LeaveDetails implements Deserializable {
  public id!: string;
  public leaveTypeId!: number;
  public leaveType!: LeaveDetailsType;
  public startDate!: string;
  public expectedReturnDate!: string | null;
  public continuedContributions!: boolean;

  // Not from API
  public formattedStartDate!: string;
  public formattedExpectedReturnDate!: string;

  onDeserialize(): void {
    if (!!this.startDate) {
      this.formattedStartDate = moment(this.startDate).utc().format('DD / MM / YYYY');
    }
    if (!!this.expectedReturnDate) {
      this.formattedExpectedReturnDate = moment(this.expectedReturnDate).utc().format('DD / MM / YYYY');
    }
    if (!!this.leaveType) {
      this.leaveType = window?.injector?.Deserialize?.instanceOf(LeaveDetailsType, this.leaveType);
    }
  }
}
